

// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

export enum FormAppClassName {

    FORM_APP                  = "form-app",
    HOME_VIEW                 = "home-view",
    LOGIN_VIEW                = "login-view",
    FORM_VALUE_VIEW           = "form-value-view",
    FORM_VALUE_LIST_VIEW      = "form-value-list-view",
    FORM_LIST_VIEW            = "form-list-view",
    PIPELINE_VIEW             = "pipeline-view",
    PIPELINE_LIST_VIEW        = "pipeline-list-view",
    PIPELINE_RUN_VIEW         = "pipeline-run-view",
    PIPELINE_RUN_LIST_VIEW    = "pipeline-run-list-view",
    AGENT_VIEW                = "agent-view",
    AGENT_LIST_VIEW           = "agent-list-view",
    PUBLIC_FORM_VIEW          = "public-form-view",
    I_FORM_VIEW               = "i-form-view",
    FORM_VIEW                 = "form-view",
    FORM_BUILDER              = "form-builder",
    PAGE_BUILDER              = "page-builder",
    FIELD_BUILDER             = "field-builder",
    NAV_LINK_ACTIVE           = "nav-link-selected",
    PIPELINE                  = "nor-pipeline",
    PIPELINE_RUN              = "nor-pipeline-run",
    PIPELINE_CONTROLLER_STATE = "nor-pipeline-controller-state",
    SELECT_PIPELINE_RUN       = "nor-select-pipeline-run",
    PIPELINE_RUN_JOB_STATE      = "nor-pipeline-run-job-state",
    PIPELINE_RUN_PIPELINE_STATE = "nor-pipeline-run-pipeline-state",
    PIPELINE_RUN_STAGE_STATE    = "nor-pipeline-run-stage-state",
    PIPELINE_RUN_STEP_STATE     = "nor-pipeline-run-step-state",
    PIPELINE_RUN_MONITOR        = "nor-pipeline-run-monitor"

}

export default FormAppClassName;
